import React from "react";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { convertThenFormat } from "../common-data/Converts";

const ClusterManagerPettyCashLists = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  clusterManagerData,
  clusterManagerDataLoading,
}) => {
  const tbColumns = [
    {
      dataField: "name",
      text: "Cluster Manager",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth180">
            <b>{row?.name || "NA"}</b>
            <br />
            <small className="underline">
              {row?.email && (
                <>
                  {row.email}
                  <br />
                </>
              )}
              {row?.mobile && (
                <>
                  {row.mobile}
                  <br />
                </>
              )}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const status = row?.status?.toLowerCase();
        return (
          <span className="tb-data">
            <span
              style={{
                color: status === "active" ? "#28a745" : "#dc3545",
                fontWeight: "bold",
                padding: "4px 8px",
                borderRadius: "4px",
                backgroundColor: status === "active" ? "#d4edda" : "#f8d7da",
                border: `1px solid ${
                  status === "active" ? "#c3e6cb" : "#f5c6cb"
                }`,
              }}
            >
              {row?.status || "NA"}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "petty_cash",
      text: "Current Balance",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth120">
            <b>₹{convertThenFormat(row?.petty_cash || 0)}</b>
          </span>
        );
      },
    },
    {
      dataField: "total_requested_petty_cash",
      text: "Total Requested",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth120">
            <b>₹{convertThenFormat(row?.total_requested_petty_cash || 0)}</b>
          </span>
        );
      },
    },
    {
      dataField: "total_recieved_petty_cash",
      text: "Total Approved",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth120">
            <b>₹{convertThenFormat(row?.total_recieved_petty_cash || 0)}</b>
          </span>
        );
      },
    },
    {
      dataField: "cluster_mapped_gyms",
      text: "Mapped Gyms",
      formatter: (_, row) => {
        const gyms = row?.cluster_mapped_gyms || [];
        return (
          <span className="tb-data minWidth200">
            {gyms.length > 0 ? (
              <div>
                <b>{gyms.length} Gym(s)</b>
                <br />
                <small className="underline">
                  {gyms.map((gym, index) => (
                    <div key={gym.gym_id || index}>
                      {gym.gym_name}
                      {index < gyms.length - 1 && <br />}
                    </div>
                  ))}
                </small>
              </div>
            ) : (
              "No gyms mapped"
            )}
          </span>
        );
      },
    },
    {
      dataField: "view_details",
      text: "View Details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "cluster_manager_details",
                  rowData: row,
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#000"
                className="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>
            </button>
          </div>
        );
      },
    },
  ];

  // if (clusterManagerDataLoading) {
  //   return (
  //     <div className="table-container">
  //       <ReactVortoxSpinner />
  //     </div>
  //   );
  // }

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30 hideMobile">
      {clusterManagerDataLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={clusterManagerData?.data || []}
          tableColumns={tbColumns}
          tablePagination={clusterManagerData?.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default ClusterManagerPettyCashLists;
